<template>
	<transition name="visible-menu">
		<div class="main_menu">
			<div v-for="(el) in option" :key='el'>
				<p :id="el" @click="clickButton">
					{{el}}
				</p>
			</div>
		</div>
	</transition>
</template>
<script>
	import optionRoot                               from "../script/optionMenu";
	import optionPW                                 from "../script/optionMenuNotKV";
	import optionOperator                           from "../script/optionOperator";
	import logsParameters                           from "../script/logsParameters";
	import usersParameters                          from "../script/usersParameters";
	import { mapActions, mapGetters, mapMutations } from "vuex";

	export default {
		name:     "mainMenu",
		data() {
			return {
				selected:   "",
				option:     [],
				parameters: []
			};
		},
		created() {
			if (this.getReqUserRole === "Администратор уровня Бог") {
				this.option = optionRoot;
			} else if (this.getReqUserRole === "Power User") {
				this.option = optionPW;
			} else if (this.getReqUserRole === "оператор") {
				this.option = optionOperator;
			}

		},
		mounted() {
			let p = document.querySelectorAll(".main_menu p");
			Array.from(p).forEach((el, i) => {
				`${i}` === this.getSelectedMenu
					? el.classList.add("selected")
					: null;
			});
		},
		computed: {
			...mapGetters([
				"getSelectedMenu",
				"getReqUserRole"
			])
		},
		methods:  {
			...mapActions([
				"setParameter",
				"setSelectedMenu",
				"setHiddenParameters",
				"setOptionForParameters",
				"setCycle",
				"setArray",
				"setPlaylists",
				"setChannelist",
				"setPlaylist"
			]),
			...mapMutations([
				"deleteArray",
				"setGenre",
				"setPrevPath"
			]),
			clickButton(e) {
				switch (e.target.id) {
					case "logs":
						this.showLogsAndUser(e, logsParameters);
						break;
					case "users":
						this.showLogsAndUser(e, usersParameters);
						break;
					case "dashboard":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/menu/dashboard");
						break;
					case "admins":
						document.documentElement.scrollTop = 0;
						this.setPrevPath(this.$route.path);
						this.$router.push("/auth");
						break;
					case "playlist":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/playlist");
						break;
					case "streamers":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/streamers");
						break;
					case "subscribers":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/subscribers");
						break;
					case "operators":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/operators");
						break;
					case "regions":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/regions");
						break;
					case "channel list":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/channel_edit");
						break;
					case "stream rating":
						document.documentElement.scrollTop = 0;
						this.selectMenu(e);
						this.$router.push("/stream_rating");
						break;
				}
			},
			showLogsAndUser(event, param) {
				document.documentElement.scrollTop = 0;
				this.setOptionForParameters(param);
				this.showLogs(event);
			},
			showLogs(e) {
				this.setHiddenParameters(false);
				this.deleteArray();
				this.selectMenu(e);
				this.$router.push(`/menu/parameters`);
				this.setParameter(e.target.id);
			},
			selectMenu(e) {
				let p = document.querySelectorAll(".main_menu p");
				Array.from(p).forEach(el => {
					el.classList.contains("selected")
						? el.classList.remove("selected")
						: null;
				});
				e.target.classList.add("selected");
				Array.from(p).forEach((el, i) => {
					el.classList.contains("selected")
						? ( this.selected = `${i}` )
						: null;
				});
				this.setSelectedMenu(this.selected);
				this.$emit("hiddenMainMenu", {
					menushow: false
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	.main_menu {
		position: fixed;
		margin-top: 3.5rem;
		min-width: 20rem;
		height: calc(100vh - 3.5rem);
		background-color: rgba(166, 238, 169, 0.81);
		z-index: 200;
		p {
			display: block;
			color: #000;
			font-size: 1.1rem;
			cursor: pointer;
			background-color: rgba(166, 238, 169, 0.4);
			transition: all 0.2s;
			margin: 0;
			padding: 0.5rem 1rem;
			height: 3rem;
			text-transform: uppercase;
			border-bottom: 1px solid #000;
			&:hover {
				margin-left: 0.7rem;
				color: #fffcff;
				background-color: rgba(151, 171, 125, 0.81);
			}
		}
		
		.visible_form {
			display: flex;
		}
		
		.selected {
			transform: translateX(0.7rem);
			color: #fffffe;
			background-color: rgba(45, 193, 53, 0.81);
		}
	}
	@media (max-width: 620px) {
		.main_menu {
			margin-top: 7.5rem;
			height: calc(100vh - 7.5rem);
		}
	}
	.visible-menu-enter-active {
		transition: all 0.5s ease;
	}
	.visible-menu-leave-active {
		transition: all 0.5s ease;
	}
	.visible-menu-enter, .visible-menu-leave-to {
		transform: translateY(-100vh);
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue